// extracted by mini-css-extract-plugin
module.exports = {"message":"NoticeChat_style_message__gnAtm","unRead":"NoticeChat_style_unRead__2HXh7","notice":"NoticeChat_style_notice__1VehQ","chat":"NoticeChat_style_chat__2_i3N"};